import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CLEAR_EAR_DATA_SUCCESS,
  CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  FETCH_ASSETS_BY_EAI_SUCCESS,
  FETCH_EAI_BY_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  SAVE_EMPLOYEE_ASSET_RECEIPT_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_EMPLOYEE_ASSET_RECEIPT_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
    data,
  };
};

export const fetchEaiByEmployeeSuccess = (data) => {
  return {
    type: FETCH_EAI_BY_EMPLOYEE_SUCCESS,
    data,
  };
};

export const fetchAssetsByEaiSuccess = (data) => {
  return {
    type: FETCH_ASSETS_BY_EAI_SUCCESS,
    data,
  };
};

export const clearEarData = () => {
  return {
    type: CLEAR_EAR_DATA_SUCCESS,
  }
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { employeeAssetReceipt } = store.getState();
      const { query } = employeeAssetReceipt;
      const response = await axios.get(`/employee-asset-receipt?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { employeeAssetReceipt } = store.getState();
      const { query } = employeeAssetReceipt;
      const response = await axios.get(`/employee-asset-receipt/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {

  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/employee-asset-receipt`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/employee-asset-receipt');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      await axios.put(`employee-asset-receipt/${id}`,payload);
      dispatch(fetchSuccess());
      history.push('/employee-asset-receipt');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/employee-asset-receipt/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/employee-asset-receipt/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchEaiByEmployee = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/employee-asset-receipt/asset/employee?id=${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchEaiByEmployeeSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
export const fetchAssetsByEai = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/employee-asset-receipt/asset/eai?id=${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsByEaiSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const cancelEai = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.post('/employee-asset-receipt/cancelEai', payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/employee-asset-receipt');
      dispatch(getResource());
    } catch(error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};


